
(function () {
  // Expander. @todo: support multiple on page, make public functions so it can be triggered externally.
  document.addEventListener("DOMContentLoaded", function() {
    const expanderTarget= document.querySelector('.js-expandable');
    const expanderToggle= document.querySelector('.js-expandable-toggle');
    const expanderChildren = document.querySelectorAll('.expandable a');
    if (expanderToggle) {
      // Activate the expander.
      expanderToggle.addEventListener('click', function (event) {
        // Don't follow the link
        event.preventDefault();
        // Toggle the expander class
        expanderTarget.classList.toggle('expandable--collapsed');
      }, false);
    }
    // Collapse the expander when a child link is clicked.
    if (expanderChildren){
      Array.prototype.forEach.call(expanderChildren, function(el, i){
        el.addEventListener('click', function (event) {
          // Toggle the expander class
          if (!expanderTarget.classList.contains('expandable--collapsed')) {
            expanderTarget.classList.add('expandable--collapsed');
          }
        }, false);
      });
    }
  });
}());
